/** Permissions tab shell: sub-tabs for Console (Django perms + groups; system
 *  users) and Dashboard (Access Groups; staff/guests with a tenant). */
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';

import type { ConsoleUserDetail } from '@/api/users';

import { DashboardPermissionsTab } from './DashboardPermissionsTab';
import { GroupsTab } from './GroupsTab';
import { PermissionsTab } from './PermissionsTab';

interface Props {
  user: ConsoleUserDetail;
  onChanged: () => void;
}

export function PermissionsContainer({ user, onChanged }: Props) {
  const hasConsole = user.kind === 'system';
  const hasDashboard = user.kind !== 'system' && user.tour_operator !== null;

  const subtabs: { id: string; label: string }[] = [];
  if (hasConsole) {
    subtabs.push({ id: 'console', label: 'Console permissions' });
    subtabs.push({ id: 'groups', label: 'Groups' });
  }
  if (hasDashboard) subtabs.push({ id: 'dashboard', label: 'Dashboard permissions' });

  const [sub, setSub] = useState(subtabs[0]?.id ?? 'console');

  if (subtabs.length === 0) {
    return <Box sx={{ color: 'text.secondary' }}>No editable permission surface for this user.</Box>;
  }

  return (
    <Box>
      {subtabs.length > 1 && (
        <Tabs value={sub} onChange={(_, v) => setSub(v)} sx={{ mb: 2 }}>
          {subtabs.map((t) => (
            <Tab key={t.id} value={t.id} label={t.label} />
          ))}
        </Tabs>
      )}
      {sub === 'console' && <PermissionsTab user={user} onChanged={onChanged} />}
      {sub === 'groups' && <GroupsTab user={user} onChanged={onChanged} />}
      {sub === 'dashboard' && <DashboardPermissionsTab user={user} onChanged={onChanged} />}
    </Box>
  );
}
